var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row admin-district-level"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.district.name))])]),_c('div',{staticClass:"col-12"},[_c('adminnavigation',{attrs:{"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }